import React, { useState, useEffect } from 'react';
import { Plus, X } from 'lucide-react';
import { api } from '../../lib/api';
import { Switch } from '../../components/ui/switch';
import { toast } from 'sonner';

export default function AdminListados() {
  const [lists, setLists] = useState([]);
  const [selected, setSelected] = useState(null);
  const [newValue, setNewValue] = useState('');

  useEffect(() => {
    api.getValueListsFresh().then((l) => {
      setLists(l);
      if (l.length) setSelected(l[0].id);
    }).catch(() => {});
  }, []);

  const list = lists.find((l) => l.id === selected);

  const persist = async (updatedValues) => {
    try {
      const updated = await api.updateValueList(selected, { values: updatedValues });
      setLists((prev) => prev.map((l) => l.id === selected ? updated : l));
      return true;
    } catch {
      toast.error('Error al guardar');
      return false;
    }
  };

  const addValue = async (e) => {
    e.preventDefault();
    if (!newValue.trim()) return;
    const id = newValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-');
    if (await persist([...list.values, { id, label: newValue.trim(), active: true }])) {
      setNewValue('');
      toast.success('Valor añadido');
    }
  };

  const toggleValue = (vid) => persist(list.values.map((v) => v.id === vid ? { ...v, active: !v.active } : v));

  const removeValue = async (vid) => {
    if (await persist(list.values.filter((v) => v.id !== vid))) toast.success('Valor eliminado');
  };

  return (
    <div data-testid="admin-listados">
      <h1 className="text-2xl font-black text-stone-800 mb-1">Listados de Valores</h1>
      <p className="text-sm text-stone-500 mb-6">Nada hardcodeado: los selectores de la tienda se alimentan de aquí.</p>

      <div className="flex flex-wrap gap-2 mb-6">
        {lists.map((l) => (
          <button key={l.id} onClick={() => setSelected(l.id)} className={`px-4 py-2 text-sm font-bold rounded-full border transition-colors ${selected === l.id ? 'bg-stone-800 text-white border-stone-800' : 'bg-white text-stone-600 border-stone-300 hover:border-stone-500'}`} data-testid={`list-tab-${l.id}`}>
            {l.name}
          </button>
        ))}
      </div>

      {list && (
        <div className="bg-white rounded-lg border border-stone-200 p-6 max-w-2xl">
          <form onSubmit={addValue} className="flex gap-3 mb-6">
            <input
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              placeholder={`Nuevo valor para “${list.name}”…`}
              className="flex-1 border border-stone-300 rounded px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
              data-testid="new-value-input"
            />
            <button type="submit" className="btn-natur flex items-center gap-1.5 px-4 py-2.5 rounded font-bold text-sm" data-testid="add-value-button">
              <Plus className="w-4 h-4" /> Añadir
            </button>
          </form>

          <div className="space-y-2">
            {list.values.map((v) => (
              <div key={v.id} className="flex items-center justify-between border border-stone-100 rounded px-4 py-2.5" data-testid={`value-row-${v.id}`}>
                <div>
                  <span className={`font-medium text-sm ${v.active ? 'text-stone-800' : 'text-stone-400 line-through'}`}>{v.label}</span>
                  <span className="text-xs text-stone-400 ml-2">({v.id})</span>
                </div>
                <div className="flex items-center gap-3">
                  <Switch checked={v.active} onCheckedChange={() => toggleValue(v.id)} />
                  <button onClick={() => removeValue(v.id)} className="text-stone-300 hover:text-red-500 transition-colors" data-testid={`remove-value-${v.id}`}>
                    <X className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
